import React from 'react';
import PropTypes from 'prop-types';
import { Grid, makeStyles } from '@material-ui/core';

import BenchmarkIndexList from './BenchmarkIndexList';
import AdvancedSearch from './AdvancedSearch';

const useStyles = makeStyles({
  subSection: {
    flexGrow: 1
  }
});

const AdvancedBenchmarkSelector = ({ index, onBenchmarkAccepted, clearAdvancedView }) => {
  const classes = useStyles();

  const onAccepted = item => {
    clearAdvancedView();
    onBenchmarkAccepted(
      {
        benchmarkId: item.timeSerieId,
        name: item.name
      },
      index
    );
  };

  return (
    <Grid item container direction="row" spacing={1} className={classes.subSection}>
      <Grid item container xs={1}>
        <BenchmarkIndexList count={6} activeIndex={index} advancedView />
      </Grid>
      <Grid item container xs={11}>
        <AdvancedSearch onAccepted={onAccepted} clearAdvancedView={clearAdvancedView} />
      </Grid>
    </Grid>
  );
};

AdvancedBenchmarkSelector.propTypes = {
  index: PropTypes.number.isRequired,
  onBenchmarkAccepted: PropTypes.func.isRequired,
  clearAdvancedView: PropTypes.func.isRequired
};

AdvancedBenchmarkSelector.defaultProps = {};

export default AdvancedBenchmarkSelector;
